import { ThunkResult } from "../reducers";
import { getSearch } from "../services/searchService";

export const indexSearch = (
  searchText: string,
  successCallback?: Function
): ThunkResult => async dispatch => {
  try {
    dispatch({
      type: "SEARCH_REQUEST",
      payload: { search: searchText }
    });
    const results = await getSearch({ searchText });

    console.log("TCL: search results", results);

    dispatch({
      type: "SEARCH_SUCCESS",
      payload: { results: results || [] }
    });

    if (successCallback) {
      successCallback(results || []);
    }
  } catch (error) {
    dispatch({
      type: "SEARCH_FAILURE",
      payload: error
    });
  }
};

export const destroySearch = (): ThunkResult => async dispatch => {
  dispatch({ type: "CLEAR_SEARCH" });
};
